import Vue from 'vue'
import * as types from '../types.js'
import urls from 'libs/urls.js'
// ajax请求方法
import axios from 'libs/http.js'

const initPageState = () => {
    return {
        // 日 月 类型的切换
        tabActiveType: '',
        // 当前请求的日期
        activeDate: new Date(),
        // 展示当前请求有数据的最新日期
        showSelectDateValue: '',
        // 选择的地区
        selectArea: {
            isSelectArea: false, //是否选择了区
            selectCityId: '', //选择了市的id
            selectAreaId: '', //选择了区的id
            selectAreaName: '' //选择了的地区的名字
        },
        typeAllList: [], //所有请求指标类型与请求接口标志 像191
        collectDate: {
            collectType: '', //收藏的指标id 类型
            collectName: '' //收藏的指标id 名称
        }
    }
}
const index = {
    state: initPageState(),
    mutations: {
        [types.SAVE_TYPE_ALL_LIST](state, pageState) {
            for (const prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_TAB_ACTIVE_TYPE](state, pageState) {
            for (let prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_ACTIVE_DATE](state, pageState) {
            for (let prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_SELECT_AREA](state, pageState) {
            for (let prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_SHOW_SELECT_DATE_VALUE](state, pageState) {
            for (let prop in pageState) {
                state[prop] = pageState[prop]
            }
        },
        [types.SAVE_COLLECT_DATA](state, pageState) {
            for (let prop in pageState) {
                state[prop] = pageState[prop]
            }
        }
    },
    actions: {}
}

export default index


// WEBPACK FOOTER //
// ./src/store/app/modules/add.js